import {
  canCreateProjects,
  canCreateTasks,
  canInviteUsers,
  canManageCalendar,
  type Capability,
} from '@/lib/auth/capabilities';
import { getEffectiveSurfaceCapabilities } from '@/lib/auth/effectiveSurfaceCapabilities';
import { getActiveScopedRelationships } from '@/lib/auth/scopedRelationshipResolver';
import type { User } from '@/types';

export type QuickActionId = 'new-project' | 'new-task' | 'invite-user' | 'schedule-meeting';

/**
 * Candidate capabilities used only to decide which launchers are meaningful.
 * The destination must still perform exact resource/action authorization.
 */
export function getQuickActionCandidateCapabilities(
  user: User | null | undefined,
): Capability[] {
  return getEffectiveSurfaceCapabilities(user);
}

export function getAvailableQuickActionIds(
  user: User | null | undefined,
  workspaceId: string | null | undefined,
): QuickActionId[] {
  if (!user || !workspaceId || user.status === 'suspended') return [];
  const belongsToWorkspace = user.workspace_id === workspaceId
    || getActiveScopedRelationships(user, 'workspace', workspaceId).length > 0;
  if (!belongsToWorkspace) return [];
  const capabilities = getQuickActionCandidateCapabilities(user);
  const actions: QuickActionId[] = [];
  if (canCreateProjects(capabilities)) actions.push('new-project');
  if (canCreateTasks(capabilities)) actions.push('new-task');
  if (canInviteUsers(capabilities)) actions.push('invite-user');
  if (canManageCalendar(capabilities)) actions.push('schedule-meeting');
  return actions;
}
